module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_alert) ? _c('div', {
    staticClass: "wrapper-email-alert-tick"
  }, [_c('div', {
    staticClass: "alert-tick alert-red"
  }, [_vm._v("!")]), _c('div', {
    attrs: {
      "id": "account-status-info",
      "align": "center"
    }
  }, [(_vm.quota_exceeded) ? _c('div', [_vm._m(0), _c('div', {
    staticClass: "body"
  }, [_vm._v("O seu servidor de email emitiu um alerta e por isso bloqueamos os envios de email na sua conta temporariamente.")]), _c('br'), _c('div', {
    staticClass: "body"
  }, [_vm._v("Você pode remover esse bloqueio ao enviar um email manualmente, mas sua conta será bloqueada novamente caso o servidor emita um novo alerta.")]), _c('br'), _c('div', {
    staticClass: "call-to-action"
  }, [_vm._v("Para saber mais "), _c('a', {
    staticClass: "call-to-action-link",
    attrs: {
      "href": _vm.to_article,
      "target": "_blank"
    }
  }, [_vm._v("clique aqui")]), _vm._v(".")])]) : _vm._e(), (!_vm.quota_exceeded) ? _c('div', [_vm._m(1), _c('div', {
    staticClass: "body"
  }, [_vm._v("Isso pode afetar o funcionamento do seu Reev.")]), (_vm.show_support_info) ? _c('div', {
    staticClass: "support-info"
  }, [_vm._v("Favor entrar em contato com o suporte.")]) : _vm._e(), (_vm.show_resync_info) ? _c('div', {
    staticClass: "resync-info"
  }, [_vm._v("Por favor, reconecte sua conta de e-mail.")]) : _vm._e(), (_vm.show_call_to_action) ? _c('div', {
    staticClass: "call-to-action"
  }, [_vm._v("Para ressincronizar o seu email "), _c('a', {
    staticClass: "call-to-action-link",
    on: {
      "click": _vm.redirect
    }
  }, [_vm._v("clique aqui")]), _vm._v(".")]) : _vm._e()]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('strong', [_vm._v("Atenção")]), _vm._v(": Limite de envios excedido!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('strong', [_vm._v("Atenção")]), _vm._v(": Email dessincronizado!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ba53dfaa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/account_status_info.vue
// module id = 1207
// module chunks = 1